// extracted by mini-css-extract-plugin
module.exports = {"textBlockRoot":"cRGodrky","title":"CzhjuMUQ","text":"lGvTS3fI","helpText":"x63lCXrM"};